export enum EEX_PATHS {
  LEGAL = "https://www.optim.finance/disclaimer",
  FAQ = "https://optim-finance.gitbook.io/optim-finance/governance",
}
